module.exports = "/static/assets/bb1ded49c939297ed7425c8534f537d8.png";